var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ContentWrapper",
    [
      _c("div", { staticClass: "content-heading" }, [
        _c("div", [_vm._v("1:1 문의관리")]),
        _c("ol", { staticClass: "breadcrumb ml-auto" }, [
          _c("li", { staticClass: "breadcrumb-item" }, [
            _c("a", { attrs: { href: "#" } }, [_vm._v("Home")])
          ]),
          _c("li", { staticClass: "breadcrumb-item" }, [
            _vm._v("\n        고객센터관리\n      ")
          ]),
          _c("li", { staticClass: "breadcrumb-item active" }, [
            _c("a", { attrs: { href: "/notice/PersonalList" } }, [
              _vm._v("1:1문의관리")
            ])
          ])
        ])
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.data.params.mode == "list",
              expression: "data.params.mode=='list'"
            }
          ],
          staticClass: "card card-default"
        },
        [
          _c("div", { staticClass: "card-body" }, [
            _c(
              "div",
              { staticClass: "form-row align-items-center" },
              [
                _c("SchDateRange", {
                  attrs: { label: "기간", data: _vm.data },
                  on: { search: _vm.search, reset: _vm.reset }
                }),
                _c("div", { staticClass: "form-group no-margin row  mr-2" }, [
                  _c("div", { staticClass: "col-auto" }, [
                    _c("label", { staticClass: "col-form-label" }, [
                      _vm._v("분류")
                    ])
                  ]),
                  _c(
                    "div",
                    { staticClass: "col-auto" },
                    [
                      _c("b-form-select", {
                        staticClass: "custom-select custom-select-sm",
                        attrs: {
                          options: _vm.searchOptionsAll,
                          name: "CatKind"
                        },
                        model: {
                          value: _vm.OptionsTextAll,
                          callback: function($$v) {
                            _vm.OptionsTextAll = $$v
                          },
                          expression: "OptionsTextAll"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-auto" },
                    [
                      _c(
                        "b-btn",
                        {
                          staticClass: "btn btn-xs btn-outline-info mr-2 mt-1",
                          staticStyle: { width: "100px" },
                          attrs: { variant: "outline-primary" },
                          on: {
                            click: function($event) {
                              _vm.popupShowAddCat = true
                            }
                          }
                        },
                        [_vm._v("분류 추가")]
                      )
                    ],
                    1
                  )
                ]),
                _c("sch-text", {
                  attrs: { label: "검색어", data: _vm.data },
                  on: { search: _vm.search, reset: _vm.reset }
                })
              ],
              1
            )
          ])
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.data.params.mode == "list",
              expression: "data.params.mode=='list'"
            }
          ],
          staticClass: "card card-default"
        },
        [
          _c(
            "div",
            { staticClass: "card-header mt-2" },
            [
              _c("span", { staticClass: "text-bold h4" }, [_vm._v("목록")]),
              _c("ShowCounter", {
                staticClass: "ml-1 mt-2 mb-0",
                attrs: { label: "Show", data: _vm.data },
                on: { search: _vm.search }
              })
            ],
            1
          ),
          _c("div", { staticClass: "card-body" }, [
            _c(
              "table",
              { staticClass: "table table-striped table-bordered table-hover" },
              [
                _c("thead", [
                  _c("tr", [
                    _c("td", { staticStyle: { "text-align": "center" } }, [
                      _vm._v("No")
                    ]),
                    _c("td", { staticStyle: { "text-align": "center" } }, [
                      _vm._v("분류")
                    ]),
                    _c(
                      "td",
                      {
                        staticStyle: { "text-align": "center" },
                        on: {
                          click: function($event) {
                            return _vm.localSort.sort("title")
                          }
                        }
                      },
                      [
                        _vm._v("제목"),
                        _c("em", { staticClass: "fa-2s mr-2 fas fa-sort" })
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: { "text-align": "center" },
                        on: {
                          click: function($event) {
                            return _vm.localSort.sort("answer")
                          }
                        }
                      },
                      [
                        _vm._v("답변상태"),
                        _c("em", { staticClass: "fa-2s mr-2 fas fa-sort" })
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: { "text-align": "center" },
                        on: {
                          click: function($event) {
                            return _vm.localSort.sort("regId")
                          }
                        }
                      },
                      [
                        _vm._v("등록자ID"),
                        _c("em", { staticClass: "fa-2s mr-2 fas fa-sort" })
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: { "text-align": "center" },
                        on: {
                          click: function($event) {
                            return _vm.localSort.sort("regDt")
                          }
                        }
                      },
                      [
                        _vm._v("등록일시"),
                        _c("em", { staticClass: "fa-2s mr-2 fas fa-sort" })
                      ]
                    )
                  ])
                ]),
                _c(
                  "tbody",
                  [
                    _c(
                      "tr",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.data.count == 0,
                            expression: "data.count==0"
                          }
                        ],
                        staticClass: "text-center"
                      },
                      [
                        _c("td", { attrs: { colspan: "9" } }, [
                          _vm._v("No matching records")
                        ])
                      ]
                    ),
                    _vm._l(_vm.data.list, function(item, index) {
                      return _c(
                        "tr",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.data.count != 0,
                              expression: "data.count!=0"
                            }
                          ],
                          key: index
                        },
                        [
                          _c(
                            "td",
                            {
                              staticClass: "align-middle text-center",
                              on: {
                                click: function($event) {
                                  return _vm.edit(item.seq)
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.data.params.limit *
                                    (_vm.data.params.page - 1) +
                                    index +
                                    1
                                )
                              )
                            ]
                          ),
                          _c(
                            "td",
                            {
                              staticClass: "align-middle text-center",
                              on: {
                                click: function($event) {
                                  return _vm.edit(item.seq)
                                }
                              }
                            },
                            [
                              _c("b-form-select", {
                                staticClass:
                                  "not-select custom-select custom-select-sm",
                                staticStyle: { width: "max-content" },
                                attrs: {
                                  options: _vm.searchOptions,
                                  value: item.boardCatSeq
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "td",
                            {
                              staticClass: "align-middle text-center",
                              on: {
                                click: function($event) {
                                  return _vm.edit(item.seq)
                                }
                              }
                            },
                            [_vm._v(_vm._s(item.title))]
                          ),
                          _c(
                            "td",
                            {
                              staticClass: "align-middle text-center",
                              on: {
                                click: function($event) {
                                  return _vm.edit(item.seq)
                                }
                              }
                            },
                            [_vm._v(_vm._s(!item.answer ? "대기" : "완료"))]
                          ),
                          _c(
                            "td",
                            {
                              staticClass: "align-middle text-center",
                              on: {
                                click: function($event) {
                                  return _vm.edit(item.seq)
                                }
                              }
                            },
                            [_vm._v(_vm._s(item.maskedRegId))]
                          ),
                          _c(
                            "td",
                            {
                              staticClass: "align-middle text-center",
                              on: {
                                click: function($event) {
                                  return _vm.edit(item.seq)
                                }
                              }
                            },
                            [_vm._v(_vm._s(item.regDt))]
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              ]
            )
          ]),
          _c("div", { staticClass: "card-footer" }, [
            _c(
              "div",
              { staticClass: "d-flex" },
              [
                _c("Pagenation", {
                  key: _vm.data.params.page,
                  attrs: { data: _vm.data },
                  on: {
                    next: function($event) {
                      return _vm.dataAction.next(_vm.search)
                    },
                    prev: function($event) {
                      return _vm.dataAction.prev(_vm.search)
                    },
                    first: function($event) {
                      return _vm.dataAction.first(_vm.search)
                    },
                    last: function($event) {
                      return _vm.dataAction.last(_vm.search)
                    }
                  }
                })
              ],
              1
            )
          ])
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.data.params.mode == "detail",
              expression: "data.params.mode=='detail'"
            }
          ],
          staticClass: "card card-default book-list"
        },
        [
          _c(
            "div",
            {
              staticClass: "card-body",
              staticStyle: { "background-color": "#fff" }
            },
            [
              _c("table", { staticClass: "table table-bordered table-hover" }, [
                _c("colgroup", [
                  _c("col", {
                    staticClass: "bg-lightdark",
                    attrs: { width: "12%" }
                  }),
                  _c("col", { attrs: { width: "38%" } }),
                  _c("col", {
                    staticClass: "bg-lightdark",
                    attrs: { width: "12%" }
                  }),
                  _c("col", { attrs: { width: "38%" } })
                ]),
                _c("tbody", [
                  _c("tr", [
                    _c("td", { staticClass: "align-middle text-center" }, [
                      _vm._v("분류")
                    ]),
                    _c(
                      "td",
                      { staticClass: "align-middle" },
                      [
                        _c("b-form-select", {
                          staticClass:
                            "not-select custom-select custom-select-sm",
                          staticStyle: { width: "max-content" },
                          attrs: { options: _vm.searchOptions },
                          model: {
                            value: _vm.data.row.boardCatSeq,
                            callback: function($$v) {
                              _vm.$set(_vm.data.row, "boardCatSeq", $$v)
                            },
                            expression: "data.row.boardCatSeq"
                          }
                        })
                      ],
                      1
                    ),
                    _c("td", { staticClass: "align-middle text-center" }, [
                      _vm._v("답변여부")
                    ]),
                    _c(
                      "td",
                      { staticClass: "align-middle", attrs: { colspan: "3" } },
                      [_vm._v(_vm._s(!_vm.data.row.answer ? "대기" : "완료"))]
                    )
                  ]),
                  _c("tr", [
                    _c("td", { staticClass: "align-middle text-center" }, [
                      _vm._v("제목")
                    ]),
                    _c(
                      "td",
                      { staticClass: "align-middle", attrs: { colspan: "3" } },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.data.row.title) +
                            "\n                "
                        )
                      ]
                    )
                  ]),
                  _c("tr", [
                    _c("td", { staticClass: "align-middle text-center" }, [
                      _vm._v("문의내용")
                    ]),
                    _c(
                      "td",
                      { staticClass: "align-middle", attrs: { colspan: "3" } },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.data.row.content) +
                            "\n                "
                        )
                      ]
                    )
                  ]),
                  _c("tr", [
                    _c("td", { staticClass: "align-middle text-center" }, [
                      _vm._v("첨부파일")
                    ]),
                    _c(
                      "td",
                      { staticClass: "align-middle", attrs: { colspan: "3" } },
                      [
                        _c("div", { staticClass: "custom-file" }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                width: "max-content",
                                position: "relative"
                              }
                            },
                            _vm._l(_vm.userAttachFiles, function(item, idx) {
                              return _c(
                                "a",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.userAttachFiles.length > 0,
                                      expression: "userAttachFiles.length>0"
                                    }
                                  ],
                                  staticClass: "popupImageItem",
                                  staticStyle: {
                                    width: "100%",
                                    "padding-top": "0"
                                  },
                                  attrs: { target: "_blank" },
                                  on: {
                                    click: function($event) {
                                      return _vm.downloadUserAttachFile(idx)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(item.name))]
                              )
                            }),
                            0
                          )
                        ])
                      ]
                    )
                  ]),
                  _c("tr", [
                    _c("td", { staticClass: "align-middle text-center" }, [
                      _vm._v("등록자")
                    ]),
                    _c("td", { staticClass: "align-middle" }, [
                      _vm._v(_vm._s(_vm.data.row.regId))
                    ]),
                    _c("td", { staticClass: "align-middle text-center" }, [
                      _vm._v("등록일시")
                    ]),
                    _c("td", { staticClass: "align-middle" }, [
                      _vm._v(_vm._s(_vm.data.row.regDt))
                    ])
                  ])
                ])
              ])
            ]
          ),
          _c(
            "div",
            {
              staticClass: "card-body",
              staticStyle: { "background-color": "#fff" }
            },
            [
              _c("table", { staticClass: "table table-bordered table-hover" }, [
                _c("colgroup", [
                  _c("col", {
                    staticClass: "bg-lightdark",
                    attrs: { width: "12%" }
                  }),
                  _c("col", { attrs: { width: "38%" } }),
                  _c("col", {
                    staticClass: "bg-lightdark",
                    attrs: { width: "12%" }
                  }),
                  _c("col", { attrs: { width: "38%" } })
                ]),
                _c("tbody", [
                  _c("tr", [
                    _c("td", { staticClass: "align-middle text-center" }, [
                      _vm._v("답변내용")
                    ]),
                    _c(
                      "td",
                      {
                        staticClass: "align-middle text-left",
                        attrs: { colspan: "3" }
                      },
                      [
                        _c("jodit-editor", {
                          style: "min-height:300px;",
                          attrs: {
                            config: _vm.jodit_config.config,
                            buttons: _vm.jodit_config.buttons,
                            plugins: _vm.jodit_config.plugins
                          },
                          model: {
                            value: _vm.data.row.answer,
                            callback: function($$v) {
                              _vm.$set(_vm.data.row, "answer", $$v)
                            },
                            expression: "data.row.answer"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("tr", [
                    _c("td", { staticClass: "align-middle text-center" }, [
                      _vm._v("첨부파일 1")
                    ]),
                    _c(
                      "td",
                      { staticClass: "align-middle", attrs: { colspan: "3" } },
                      [
                        _c("div", { staticClass: "custom-file" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.fileCheck.file1 == null &&
                                    _vm.uploadImageFile.file1 == null,
                                  expression:
                                    "fileCheck.file1 == null && uploadImageFile.file1 == null"
                                }
                              ]
                            },
                            [
                              _c("input", {
                                staticClass: "display-file",
                                attrs: {
                                  type: "file",
                                  accept: "image/*",
                                  id: "file1"
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.insertFileName($event, "0")
                                  }
                                }
                              }),
                              _c(
                                "label",
                                {
                                  staticClass: "custom-file-label",
                                  attrs: { for: "file1" }
                                },
                                [_vm._v("Choose a file...")]
                              )
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                width: "max-content",
                                position: "relative"
                              }
                            },
                            [
                              _c(
                                "a",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.uploadImageFile.file1 != null,
                                      expression:
                                        "uploadImageFile.file1 != null"
                                    }
                                  ],
                                  staticClass: "popupImageItem",
                                  staticStyle: {
                                    width: "100%",
                                    "padding-top": "0"
                                  },
                                  attrs: { target: "_blank" },
                                  on: {
                                    click: function($event) {
                                      return _vm.downloadAs(0)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.fileName.name1))]
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "btn_remove",
                                  on: {
                                    click: function($event) {
                                      return _vm.fileRemove(
                                        _vm.fileCheck.file1.seq,
                                        0
                                      )
                                    }
                                  }
                                },
                                [_vm._v("X")]
                              )
                            ]
                          )
                        ])
                      ]
                    )
                  ]),
                  _c("tr", [
                    _c("td", { staticClass: "align-middle text-center" }, [
                      _vm._v("답변자ID")
                    ]),
                    _c("td", { staticClass: "align-middle" }, [
                      _vm._v(_vm._s(_vm.data.row.answerAdminId))
                    ]),
                    _c("td", { staticClass: "align-middle text-center" }, [
                      _vm._v("답변일시")
                    ]),
                    _c("td", { staticClass: "align-middle" }, [
                      _vm._v(_vm._s(_vm.data.row.answerDt))
                    ])
                  ])
                ])
              ])
            ]
          ),
          _c("div", { staticClass: "footer mt-2 mb-3" }, [
            _c(
              "div",
              { staticClass: "float-right" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "btn btn-b btn-danger mr-2",
                    attrs: { variant: "info mr-2" },
                    on: {
                      click: function($event) {
                        return _vm.remove()
                      }
                    }
                  },
                  [_vm._v("삭제")]
                ),
                _c(
                  "b-button",
                  {
                    staticClass: "btn btn-b btn-outline-info mr-2",
                    attrs: { variant: "outline-info mr-2" },
                    on: {
                      click: function($event) {
                        return _vm.search()
                      }
                    }
                  },
                  [_vm._v("목록")]
                ),
                _c(
                  "b-button",
                  {
                    staticClass: "btn btn-b btn-info mr-2",
                    attrs: { variant: "info mr-2" },
                    on: {
                      click: function($event) {
                        return _vm.save()
                      }
                    }
                  },
                  [_vm._v("저장")]
                )
              ],
              1
            )
          ])
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: { id: "uploadModalFiles", size: "s", title: "개체연결" },
          model: {
            value: _vm.popupShowAddCat,
            callback: function($$v) {
              _vm.popupShowAddCat = $$v
            },
            expression: "popupShowAddCat"
          }
        },
        [_c("BoardCatList", { attrs: { catType: "04" } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }